import { render, staticRenderFns } from "./Audit-list.vue?vue&type=template&id=5c52b424&"
import script from "./Audit-list.vue?vue&type=script&lang=js&"
export * from "./Audit-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports